import { EMPTY_ROOT_CONTAINER_PROPS } from "@client/content/lib/consts";
import { getEntityRef } from "@client/content/lib/helper";
import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { API_INFO } from "@client/lib/api";
import { getNoImageUrl } from "@client/lib/assets";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { setShowingDetailId, showAddCommentModal } from "../actions";
import { localStateSelector } from "../selectors";
import Component, { type ActionProps, type MapProps } from "./component";

const INVISIBLE_PROPS: MapProps = {
  ...EMPTY_ROOT_CONTAINER_PROPS,
  apiInfo: API_INFO,
  isEditMode: false,
  noImageUrl: "",
  detail: null,
  id: "",

  isVisible: false,
  status: "None"
};

const makeMapStateToProps = () => {
  const apiInfoSelector = makeModuleApiInfoSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);
    if (!localState.showingDetailId) return INVISIBLE_PROPS;

    const order = localState.detail[localState.showingDetailId]!;

    return {
      ...props,
      apiInfo: apiInfoSelector(state, props),
      isEditMode: state.isEditMode,
      detail: order.detail,

      isVisible: true,
      noImageUrl: getNoImageUrl(),
      status: order.status
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onClose: () => dispatch(setShowingDetailId({ ...getEntityRef(props), itemId: null })),
  onClickAddComment: () => dispatch(showAddCommentModal(getEntityRef(props)))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
